import { useContext } from "react";
import {
  CompanySegmentContext,
  CompanySegmentContextData,
} from "../contexts/CompanySegment";

export function useCompanySegment(): CompanySegmentContextData | null {
  const context = useContext(CompanySegmentContext);

  // if (!context) {
  //   throw new Error(
  //     "useCompanySegment must be used within an CompanySegmentProvider"
  //   );
  // }

  return context;
}
